import { Link } from "remix";

export default function SignUp() {
  return (
    <div className="md:flex md:flex-col md:justify-center md:items-center">
      <h1>What type of account do you want to create</h1>
      <div className="md:grid md:grid-cols-3">
        <div className="bg-red-600">
          <Link to="teacher">A teacher account</Link>
        </div>
        <div className="bg-blue-600">
          <Link to="student">A student account</Link>
        </div>
        <div className="bg-red-600">
          <Link to="school">A school account</Link>
        </div>
      </div>
    </div>
  );
}
